const SEQUENTIAL_FROM_HSL = { h: 231, s: 62, l: 80 };
const SEQUENTIAL_TO_HSL = { h: 232, s: 56.44, l: 19.88 };

function hslString(h: number, s: number, l: number): string {
  return `hsl(${Math.round(h)}, ${Math.round(s)}%, ${Math.round(l)}%)`;
}

export function sequentialColors(count: number): string[] {
  if (count <= 0) return [];
  if (count === 1) return [hslString(SEQUENTIAL_TO_HSL.h, SEQUENTIAL_TO_HSL.s, SEQUENTIAL_TO_HSL.l)];
  return Array.from({ length: count }, (_, i) => {
    const t = i / (count - 1);
    const h = SEQUENTIAL_FROM_HSL.h + (SEQUENTIAL_TO_HSL.h - SEQUENTIAL_FROM_HSL.h) * t;
    const s = SEQUENTIAL_FROM_HSL.s + (SEQUENTIAL_TO_HSL.s - SEQUENTIAL_FROM_HSL.s) * t;
    const l = SEQUENTIAL_FROM_HSL.l + (SEQUENTIAL_TO_HSL.l - SEQUENTIAL_FROM_HSL.l) * t;
    return hslString(h, s, l);
  });
}

// seaborn "deep" qualitative palette: https://seaborn.pydata.org/tutorial/color_palettes.html
const CATEGORICAL_PALETTE = [
  '#4c72b0',
  '#dd8452',
  '#55a868',
  '#c44e52',
  '#8172b2',
  '#937860',
  '#da8bc3',
  '#8c8c8c',
  '#ccb974',
  '#64b5cd',
];

export function categoricalColors(count: number): string[] {
  return Array.from({ length: count }, (_, i) => CATEGORICAL_PALETTE[i % CATEGORICAL_PALETTE.length]);
}
